import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ProductsPage } from './_dashboard.catalog.products'

export const Route = createFileRoute('/_dashboard/catalog/products/')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ProductsIndexPage,
})

function ProductsIndexPage() {
  return <ProductsPage selectedId={undefined} />
}
